<template>
<!-- 课程 -->
    <div>
        <div class="title clear">
            <p class="fl">
                <img src="@/assets/logoe.png" alt="">
                同步课程
            </p>
            <p @click="go" class="fr">查看更多</p>
        </div>

        <div v-if="ashow">
            <div class="wrapper" ref="wrapper">
                <ul ref="cont" class="clear">
                    <li v-for="(item,index) in arr_tb" :key="index" @click="infobtn(item)" class="fl">
                        <img :src="item.cs_picture" alt="">
                        <div>
                            <p class="fl">{{list[item.subject_id - 1].name}}</p> 
                            <p class="fl">{{item.cs_name}}</p>                        
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else class="zanwu">暂无课程</div>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
import URL from '../api/index'
import VueEvent from '../model/VueEvent'
import $ from 'jquery'
export default {

    name: '',
    data () {
        return {
            arr_tb:[],  
            ashow:true,
            data:{
                top_id:5,
                grade_id:0,
                subgect_id:0,
                press_id:0,
                page_id:1,
            },
            word:'',
            icoType:'',  
            list:[
                {id:'1',name:'语文'},
                {id:'2',name:'数学'},
                {id:'3',name:'英语'},
            ]
        }     
    },
    inject:["reload"],
    beforeMount(){
        this.data.grade_id = JSON.parse(localStorage.getItem("grade_id"))    
        this.http_tb() 
    },
    watch:{
        'word'(val){
            this.http_tb() 
        },
        'data.grade_id'(val){
            this.http_tb()
        },
        deep:true
    },
    mounted(){
        this.icoType = this.$route.query.icoType
        var that = this
        VueEvent.$on('word',function(data){
            that.word = data
        })
        VueEvent.$on('grade',function(data){
            that.data.grade_id=data
        })
        this.getuser()
    },
    methods:{
        go(){
            this.knowledgework()
            this.$router.push('/course')
        },
        infobtn(item){
            localStorage.setItem('retrue', true)
            this.$router.push({
                name:'newclassdetails',
                query:{
                    csid: item.id,
                    icoType: this.icoType,
                    icotype: '1',
                 }
            })
        },
        async http_tb(){                                                              
            var that=this
            await this.$axios({
            method:'post',
            url:URL.get_course_list,
            data:{
                keywords:that.word,
                top_id:that.data.top_id,
                grade_id:that.data.grade_id,
                subject_id:that.data.subgect_id,
                press_id:that.data.press_id,
                page:that.data.page_id
            }
            }).then((res)=>{
                if(res.data.state==1){
                    that.ashow=false
                }else{
                    that.ashow=true
                }
                that.arr_tb=res.data.result.splice(0,6)
                this.verScroll(this.arr_tb.length)
            })
        },
        verScroll (aaa) {
            var that = this
            let kuan = aaa *151 + 15
            that.$refs.cont.style.width = kuan / 37.5 + 'rem'
            this.$nextTick(() => {
                if (!this.scroll) {
                    that.scroll = new BScroll(that.$refs.wrapper, {
                        startX: 0,
                        click: true,
                        scrollX: true,
                        scrollY: true,
                        eventPassthrough: 'vertical'
                    })
                } else {
                    this.scroll.refresh()
                }
            })
        },

        // 数据上报
        // 个人信息 
        getuser(){
            this.$axios({
                method: "post",
                url: 'https://api.rujiaowang.net/index.php/api/user/get_user',
                data: {
                token: localStorage.getItem('token'),
                },
            }).then(res =>{
                this.iteminfo = res.data.result
            })
        },
        // 同步课程
        knowledgework(){
            this.$axios({
                method: "get",
                url: 'http://access.rujiaowang.net/GetLogServer',
                data: {
                    token: localStorage.getItem('token'),
                },
            }).then(res =>{
                this.client_ip = res.data.result.client_ip
                var actualtime = res.data.result.net_ts - Date.parse(new Date()) / 1000 // 服务器时间跟计算机时间差值

                if(JSON.parse(localStorage.getItem("userInfo")).user_type == 3){
                    var school_name = String(this.iteminfo.school) //学校
                    var school_id = String(this.iteminfo.school_id) //学校id
                    var data1 = {
                        school_name: school_name,
                        school_id: school_id,
                        trace_id: localStorage.getItem('apptrace'),
                    }
                } else if(JSON.parse(localStorage.getItem("userInfo")).user_type == 5){
                    var school_name = String(this.iteminfo.school) //学校
                    var school_id = String(this.iteminfo.school_id) //学校id
                    var grade_id = String(this.iteminfo.grade) //学校id
                    var class_name = String(this.iteminfo.myclass) //学校id
                    var class_id = String(this.iteminfo.myclass_id) //学校id
                    var list = [
                        {id:1,text:'一'},
                        {id:2,text:'二'},
                        {id:3,text:'三'},
                        {id:4,text:'四'},
                        {id:5,text:'五'},
                        {id:6,text:'六'},
                        {id:7,text:'七'},
                        {id:8,text:'八'},
                        {id:9,text:'九'},
                    ]
                    for (let index = 0; index < list.length; index++) {
                        if(grade_id == list[index].id){
                            var grade_name = list[index].text
                        }
                    }
                    var data1 = {
                        school_name: school_name,
                        school_id: school_id,
                        grade_name: grade_name + '年级',
                        grade_id: grade_id,
                        class_name: class_name,
                        class_id: class_id,
                        trace_id: localStorage.getItem('apptrace'),
                    }
                } else if(JSON.parse(localStorage.getItem("userInfo")).user_type == 2) {
                    var data1 = {
                        trace_id: localStorage.getItem('apptrace'),
                    }
                }
                if(this.Mobile == 'pad'){
                    var saydata = {
                        log_version: "v2.0.0", 
                        action:  "synchronization_entrance",
                        product_name: localStorage.getItem('product_name'),
                        user_id: String(this.iteminfo.user_id),
                        user_role: String(this.iteminfo.user_type),
                        ts: String(Number(Date.parse(new Date())) / 1000 + actualtime), // 真实时间
                        trace_id: localStorage.getItem('trace'),
                        dev_id: '',
                        dev_name: '',
                        client_ip: this.client_ip,
                        os: '',
                        cpu_name: '',
                        cpu_use: '',
                        app_version: 'v2.0.0',
                        mem_size: '',
                        mem_use: '',
                        net: '',
                        electric: '',
                        user_name: this.iteminfo.user_nicename,
                        "@": '',
                        extend: '',
                        remark: String(this.iteminfo.user_nicename + '进入了同步课程'),
                        data: data1
                    }
                    $.ajax({
                        method: "post",
                        url: 'http://47.114.114.56:9002/RecordRjw',
                        data: JSON.stringify(saydata),
                    }).then(res =>{})
                } 
                else {
                    var saydata = {
                        log_version: "v2.0.0", 
                        action:  "synchronization_entrance",
                        product_name: localStorage.getItem('product_name'),
                        user_id: String(this.iteminfo.user_id),
                        user_role: String(this.iteminfo.user_type),
                        ts: String(Number(Date.parse(new Date())) / 1000 + actualtime), // 真实时间
                        trace_id: localStorage.getItem('trace'),
                        dev_id: '',
                        dev_name: '',
                        client_ip: this.client_ip,
                        os: '',
                        cpu_name: '',
                        cpu_use: '',
                        app_version: 'v2.0.0',
                        mem_size: '',
                        mem_use: '',
                        net: '',
                        electric: '',
                        user_name: this.iteminfo.user_nicename,
                        "@": '',
                        extend: '',
                        remark: String(this.iteminfo.user_nicename + '进入了同步课程'),
                        data: data1
                    }
                    $.ajax({
                        method: "post",
                        url: 'http://47.114.114.56:9002/RecordRjw',
                        data: JSON.stringify(saydata),
                    }).then(res =>{})
                }
            })
        }
    }
}
</script>
<style scoped>
.title{
    padding: 0 0.4rem;
    line-height: 50px;
}
.title p:first-child{
    font-size: 16px;
}
.title p:first-child img{
    width: 20px;
}
.title p:last-child{
    color: #a9a9a9;
    font-size: 0.32rem;
}
.wrapper {
    width: 100%;
    overflow: hidden;
    touch-action: none;
}

.wrapper ul {
    padding-left: 0.4rem;
    height: 3.49333rem;
}
.wrapper ul li {
    border-radius: 0.26666rem;
    width: 3.89333rem;
    float: left;
    margin-right: 0.13333rem;
    touch-action: none;
    background-color: #fff;
    box-shadow: 0rem 0rem 0.32rem rgba(51, 51, 51, 0.24);
}

.wrapper ul li img {
    border-top-left-radius: 0.26666rem;
    border-top-right-radius: 0.26666rem;
    width: 100%;
    height: 86px;
    border: none;
}

.wrapper ul li div {
    height: 20px;
    font-size: 0.32rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.wrapper ul li div p:first-child{
    line-height: 0.42666rem;
    background-color: #ff7038;
    margin: 0 0.26666rem;
    width: 0.96rem;
    border-top-left-radius: 0.16rem;
    border-bottom-right-radius: 0.16rem;
    text-align: center;
    color: #f2f2f2;
}
.wrapper ul li div p:last-child{
    line-height: 0.42666rem;
    width: 50%;
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
}
.zanwu{
    font-size: 16px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/shouyeTongbu.vue